import { render, staticRenderFns } from "./PackagesList.vue?vue&type=template&id=9abda84a&scoped=true"
import script from "./PackagesList.vue?vue&type=script&lang=js"
export * from "./PackagesList.vue?vue&type=script&lang=js"
import style0 from "./PackagesList.vue?vue&type=style&index=0&id=9abda84a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9abda84a",
  null
  
)

export default component.exports